import Api from "../axios"

export const getPlan=async(id)=>{
    return await Api.get(`/Global/Plan?planId=${id}`)
}
